import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

const assignment = {
  assignedWorkerId: entityIdSchema.nullable(),
  assignedCrewId: entityIdSchema.nullable(),
  assignedResourceIds: z.array(entityIdSchema).max(20).refine(
    (values) => new Set(values).size === values.length,
    "Assigned resources must be unique.",
  ),
}

export const visitReadinessEvaluateV1Schema = z.object({
  readinessId: entityIdSchema,
  visitId: entityIdSchema,
  serviceOrderId: entityIdSchema,
  candidateVisitVersion: z.number().int().nonnegative(),
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  timezone: z.string().min(1).max(64),
  ...assignment,
}).strict()
  .refine((value) => value.startsAt < value.endsAt, {
    path: ["endsAt"],
    message: "Visit must end after it starts.",
  })
  .refine(
    (value) =>
      (value.assignedWorkerId === null) !== (value.assignedCrewId === null),
    {
      path: ["assignedWorkerId"],
      message: "Visit must have exactly one worker or crew assignment.",
    },
  )

export const visitScheduleV2Schema = z.object({
  visitId: entityIdSchema,
  serviceOrderId: entityIdSchema,
  readinessId: entityIdSchema,
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  timezone: z.string().min(1).max(64),
  ...assignment,
}).strict()
  .refine((value) => value.startsAt < value.endsAt, {
    path: ["endsAt"],
    message: "Visit must end after it starts.",
  })
  .refine(
    (value) =>
      (value.assignedWorkerId === null) !== (value.assignedCrewId === null),
    {
      path: ["assignedWorkerId"],
      message: "Visit must have exactly one worker or crew assignment.",
    },
  )

export const visitRescheduleV2Schema = z.object({
  readinessId: entityIdSchema,
  startsAt: z.iso.datetime({ offset: true }),
  endsAt: z.iso.datetime({ offset: true }),
  timezone: z.string().min(1).max(64),
  reason: z.string().trim().min(1).max(500),
}).strict().refine((value) => value.startsAt < value.endsAt, {
  path: ["endsAt"],
  message: "Visit must end after it starts.",
})

export const visitReadinessOverrideV1Schema = z.object({
  overrideId: entityIdSchema,
  readinessId: entityIdSchema,
  reason: z.string().trim().min(1).max(500),
}).strict()

export const operationalHoldPlaceV1Schema = z.object({
  holdId: entityIdSchema,
  targetType: z.enum(["service_order", "visit"]),
  targetId: entityIdSchema,
  reasonCode: z.enum([
    "customer_request",
    "commercial_review",
    "safety_review",
    "resource_review",
    "other",
  ]),
  reason: z.string().trim().min(1).max(500),
  startsAt: z.iso.datetime({ offset: true }),
  expiresAt: z.iso.datetime({ offset: true }).nullable(),
}).strict().refine(
  (value) => value.expiresAt === null || value.startsAt < value.expiresAt,
  {
    path: ["expiresAt"],
    message: "Hold expiry must be after its start.",
  },
)

export const operationalHoldReleaseV1Schema = z.object({
  reason: z.string().trim().min(1).max(500),
}).strict()
